import { useCallback, useMemo } from "react";
import { TachographDueSettings } from "../models/Tachograph";
import { DEFAULT_DUE_SETTINGS, normalizeDueSettings } from "../utilities/tachographDueSettings";
import { useUserState } from "@/hooks/userState/useUserState";

/** The user's readout deadlines and warning window; the legal deadlines until they change them. */
export function useTachographDueSettings() {
  const { value, setValue, isReady } = useUserState<Partial<TachographDueSettings>>(
    "tachograph:dueSettings",
    DEFAULT_DUE_SETTINGS,
  );

  const settings = useMemo(() => normalizeDueSettings(value), [value]);

  const updateSettings = useCallback(
    (change: Partial<TachographDueSettings>) =>
      setValue(current => ({ ...normalizeDueSettings(current), ...change })),
    [setValue],
  );

  const resetSettings = useCallback(() => setValue(DEFAULT_DUE_SETTINGS), [setValue]);

  return { settings, updateSettings, resetSettings, isReady };
}
